import { Directive } from '@angular/core';
import { getPaymentFrequencyLabel } from 'src/app/_enums/payment-frequency.enum';
import { getBooleanLabel } from 'src/app/_helpers/utils';
import { BusinessCyberInsuranceMetadata } from 'src/app/_types/lead.types';

import { BaseMetadataComponent } from '../../base-metadata.component';

@Directive()
export abstract class BusinessCyberMetadataComponentAbstract extends BaseMetadataComponent<BusinessCyberInsuranceMetadata> {
  getBooleanLabel = getBooleanLabel;

  labelPaymentFrequency = getPaymentFrequencyLabel;

  hasGeneralInfo(data?: BusinessCyberInsuranceMetadata): boolean {
    if (!data) return false;
    return [
      data.startDate,
      data.contractDuration,
      data.paymentFrequency,
      data.splitPaymentFee,
      data.hasclaimsLastFiveYears,
      data.claims,
    ].some((v: any) => v !== null && v !== undefined && v !== '');
  }

  isSectionEmpty(section?: Record<string, any> | null): boolean {
    if (!section) return true;
    const values = Object.values(section);
    if (!values.length) return true;
    return !values.some((v) => v !== null && v !== undefined && v !== '');
  }
}
